let isLoggedOut = false;
let controllers = [];

let logoutCallback = null;

export const registerLogoutCallback = (callback) => {
  logoutCallback = callback;
};

export const triggerLogout = () => {
  if (isLoggedOut) return;
  isLoggedOut = true;

  // Abort inflight requests
  controllers.forEach((ctrl) => ctrl.abort());
  controllers = [];

  if (typeof logoutCallback === "function") {
    logoutCallback();
  } else {
    localStorage.setItem("is_forced_sign_out", "true");
    localStorage.removeItem("consentModalDismiss");
    window.location.href = "/login";
  }
};

export const createAbortController = () => {
  if (isLoggedOut) {
    const ctrl = new AbortController();
    ctrl.abort(); // immediately cancel if logged out
    return ctrl;
  }
  const ctrl = new AbortController();
  controllers.push(ctrl);
  return ctrl;
};

export const resetLogout = () => {
  isLoggedOut = false;
  controllers = []; // clear old controllers
};
